import { render, staticRenderFns } from "./DashboardTabs.vue?vue&type=template&id=7aa3d0bd&"
import script from "./DashboardTabs.vue?vue&type=script&lang=js&"
export * from "./DashboardTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aa3d0bd')) {
      api.createRecord('7aa3d0bd', component.options)
    } else {
      api.reload('7aa3d0bd', component.options)
    }
    module.hot.accept("./DashboardTabs.vue?vue&type=template&id=7aa3d0bd&", function () {
      api.rerender('7aa3d0bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/dashboard/components/DashboardTabs.vue"
export default component.exports